<template>
    <div class="bill_account row">
        <div class="col-sm-4">
            <div class="form-group" v-if="billAccount.bill_name">
                <label>Account Name:</label><br />
                {{ billAccount.bill_name }}
            </div>
            <div class="form-group">
                <label>Account Type:</label>
                {{ billAccountTypeLabel }}
            </div>
            <div class="form-group" v-if="billAccount.area_type_id">
                <label>Area Type:</label>
                {{ billAccountAreaTypeLabel }}
            </div>
        </div>
        <div class="col-sm-4">
            <div class="form-group" v-if="billAccount.address">
                <label>Address:</label><br />
                {{ billAccount.address.address }}<br />
                <span v-if="billAccount.address.address2">{{ billAccount.address.address2 }}<br /></span>
                {{ billAccount.address.city }}, {{ billAccount.address.state }} {{ billAccount.address.zip }}
                <span v-if="billAccount.address.additional_zip">-{{ billAccount.address.additional_zip}}</span>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="form-group actions" v-if="!disabled">
                <button v-if="canUpdate" @click.prevent="showModal" class="inputbutton1">Edit</button><br />
                <button @click.prevent="removeBillAccount" class="inputbutton1">Remove</button>
            </div>
        </div>

        <modal
            v-if="showEditModal"
            modalWidth="600px"
            @close="showEditModal = false">

            <span slot="header">Edit Account</span>

            <slot slot="body">
                <bill-account-form
                    :bill-account="billAccount"
                    :disabled="disabled"
                    @savedBillAccount="updateBillAccount"
                    @close="showEditModal=false"></bill-account-form>
            </slot>
        </modal>

    </div>
</template>
<script>
    import axios from 'axios';
    import str_utils from 'etap/mixins/str_utils'
    export default {

        mixins: [str_utils],

        props: {
            billAccount: {
                required: true,
                type: Object
            },
            disabled: {
                type: Boolean,
                require: false,
                default: false
            }
        },

        inject: {
            projectId: {
                default() {
                    return null;
                }
            },
            billAccountFormConfiguration: {
                default() {
                    console.error('Invalid Form Configuration provided');
                    return null;
                }
            }
        },


        created() {
            this.$store.dispatch('lookup/getLookupForModel', {
                model: 'account.area_type',
                date_flag_filter: true
            });
        },

        data() {
            return {
                showEditModal: false
            }
        },

        computed: {
            canUpdate() {
                return this.$can('update', window.MAT.model_map.project_bill_account);
            },
            hasPeakUsageField() {
                var hasField = false;
                this.billAccountFormConfiguration.fields.forEach(field => {
                    if(field.value_field === 'peak_usage' && field.visible !== 0 ) {
                        hasField = true;
                    }
                });

                if(this.billAccount.account_type === 'gas') {
                    hasField = false;
                }

                return hasField;
            },
            billAccountTypeLabel() {
                // TODO: migrate bill account types to lookups

                switch(this.billAccount.account_type) {
                    case 'electric':
                        return 'Electric';
                        break;
                    case 'gas':
                        return 'Gas';
                        break;
                    case 'electric_and_gas':
                        return 'Electric & Gas';
                        break;
                }

                return '';
            },

            billAccountAreaTypeLabel() {
                let lookups = this.$store.getters['lookup/getLookupsForModel'](
                    'account.area_type'
                );

                return lookups.find(lookup => {
                    return lookup.id == this.billAccount.area_type_id;
                })?.name;
            }
        },

        methods: {
            showModal() {
                this.showEditModal = true;
            },
            updateBillAccount(billAccount) {
                this.showEditModal = false;
                this.$emit('updateBillAccount', billAccount)
            },
            removeBillAccount() {

                axios.delete('/api/bill_accounts/project/' + this.projectId, {
                    data: {
                        projectBillAccountId: this.billAccount.id
                    }
                }).then( response => {

                    this.$emit('deleteBillAccount', this.billAccount);

                }).catch( error => {
                    window.notify.apiError(error);
                })

            }
        }

    }
</script>
<style lang="scss">
    .bill_account {
        border: 1px dotted;
        border-radius: 5px;
        margin: 10px 0;
        padding:5px;

        .actions {
            button {
                margin: 5px;
            }
        }
    }
</style>
